import supabaseClient from '@/api/supabaseClient.ts';
import type { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import type { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import type { UpdateRegisteringUserRequest } from '$/requests/UpdateRegisteringUser.ts';
import { FunctionsHttpError, type SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';

const useUpdateRegisteringUser = () => {
  const mutationFn = async (request: UpdateRegisteringUserRequest) => {
    return updateRegisteringUser(supabaseClient, request);
  };

  return useMutation({ mutationFn });
};

export default useUpdateRegisteringUser;

async function updateRegisteringUser(
  client: SupabaseClient,
  request: UpdateRegisteringUserRequest
): Promise<BackendSuccessResponse<{ message: string; token: string }>> {
  const { data, error } = await client.functions.invoke('update_registering_user', {
    body: request,
  });

  if (error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  if (error) {
    throw error;
  }

  return data;
}
